// src/PrivacyPolicy.js
import React from "react";
import "./PrivacyPolicy.css";
import Header from "./components/Header/Header";
const PrivacyPolicy = () => {
  return (
    <>
      <Header />
      <div className="privacy-policy">
        <h1>Privacy Policy</h1>
        <section>
          <h2>Introduction</h2>
          <p>
            All-Cures understands how important the privacy of personal
            information is to our users. This Privacy Policy will tell you what
            information we collect about you and about your use of All-Cures.com
            and its services. It will explain the choices you have about how
            your personal information is used and how we protect that
            information. We urge you to read this Privacy Policy carefully.
          </p>
          <p>
            This Privacy Policy applies to websites owned and operated by
            All-Cures that are intended for use by consumers (non-professionals)
            for non-commercial personal, family or household purposes, including
            All-Cures.com, etheriumtech.com and including the mobile optimized
            versions of these sites and our Mobile Device Applications or "Apps"
            (we refer to these sites and Apps collectively as the “All-Cures.com
            Sites”). We refer to the All-Cures.com Sites and Apps, along with
            the information and services made available to you through the
            All-Cures.com Sites and Apps, as the “Services.”
          </p>
          <p>
            This Privacy Policy also applies to the consumer-facing version of
            the All-Cures.com. Except where noted, statements in this Privacy
            Policy with respect to the All-Cures.com also apply to the Apps. If
            you do not want us to collect, use or disclose information about you
            and your use of the Services as described in this Privacy Policy,
            then you should not use the Services. By using the Services, you
            must agree to the All-Cures.com Terms of Use, which is the contract
            between us and users of the Services. By accepting the All-Cures.com
            Terms of Use, you confirm that you have read and understand this
            Privacy Policy and the All-Cures.com Cookie Policy and you
            acknowledge that we will store, use and otherwise process your
            information in India where we are located.
          </p>
          <p>
            References to "All-Cures.com," “we” or “us” mean All-Cures.com,
            including any company that All-Cures.com controls (for example, a
            subsidiary that All-Cures.com owns). All-Cures.com may share
            information among its subsidiaries or websites that it owns or
            controls, but information collected under this Privacy Policy is
            always protected under the terms of this Privacy Policy. Except as
            otherwise noted in this Privacy Policy, All-Cures.com is the data
            controller responsible for the processing of your personal
            information as described in this Privacy Policy.
          </p>
        </section>
        <section>
          <h2>Information Collected About You</h2>
          <p>
            Even if you do not register with or provide any personal information
            to All-Cures.com, we collect information about your use of the
            All-Cures.com Sites and Apps and the Services. We may also acquire
            information about our users from external sources.
          </p>
          <h3>Registration</h3>
          <p>
            While you may use most of the Services without registering, certain
            Services do require that you register with All-Cures.com for them to
            function properly. If you choose to register or update an existing
            account with All-Cures.com or access certain Services, you may be
            required to provide certain personal information, such as your name,
            address, telephone number, gender, email address and date of birth,
            and a username and password to access your All-Cures.com account.
            You are responsible for ensuring the accuracy of the personal
            information that you submit to All-Cures.com.
          </p>
          <h3>Interactive Services</h3>
          <p>
            Some of our Services may be interactive and may request that you
            submit health-related information, along with other information such
            as your age and gender. You are not required to register with
            All-Cures.com to use such services and if you are registered with
            All-Cures.com, we do not associate information that you submit to
            the interactive service with registration information that you have
            previously provided.
          </p>
          <h3>Email Newsletters</h3>
          <p>
            At registration and at various times as you use the All-Cures.com
            Sites, you will be given the option of providing us with personal
            information in order to receive informational/promotional
            newsletters – such as a newsletter relating to a specific health
            condition – via email from All-Cures.com and/or directly from third
            parties. From time to time All-Cures.com may offer users of third
            party websites the opportunity to subscribe to our newsletters
            through those websites. If you elect to subscribe to one of our
            newsletters on a third party website, the operator of that website
            will provide us with the personal information you have provided in
            connection with the subscription request, which we may use in
            accordance with this Privacy Policy as though you had provided it
            directly to All-Cures.com.
          </p>
          <h3>Market Research</h3>
          <p>
            From time to time, All-Cures.com may conduct online research surveys
            on behalf of itself and third parties through email invitations,
            pop-up surveys and online focus groups. When participating in a
            survey, we may require you to provide your location, age. The
            information you submit in a survey may be used by All-Cures.com for
            research and measurement purposes, as described below, including
            measuring the effectiveness of content, advertising or programs. We
            will not knowingly invite individuals who are under the age of 13 to
            participate in market research surveys. Market research surveys
            conducted by or on behalf of All-Cures.com will contain a link to
            this Privacy Policy.
          </p>
          <h3>User Reviews and Other Public Forums</h3>
          <p>
            In connection with the use of our Physician Directory, users are
            able to submit provider reviews. Our reviews feature in the
            Physician Directory and are open to the public and should not be
            considered private. Any information (including personal information)
            you share in any review, or other forum is by design open to the
            public and is not private. You should think carefully before posting
            any personal information in any public forum. What you post can be
            seen, disclosed to or collected by third parties and may be used by
            others in ways we cannot control or predict, including to contact
            you for unauthorized purposes. As with any public forum on any site,
            the information you post may also show up in third-party search
            engines.
          </p>
          <h3>Emails You Send to All-Cures.com</h3>
          <p>
            This Privacy Policy does not apply to information, content, business
            information, ideas, concepts or inventions that you send to
            All-Cures.com by email. If you want to keep content or business
            information, ideas, concepts or inventions private or proprietary,
            do not send them in an email to All-Cures.com.
          </p>
          <h3>Services and Device Information</h3>
          <p>
            When you access and use the Services, All-Cures.com automatically
            collects and stores in its server logs information from your browser
            or mobile device such as your IP address or unique device
            identifier, browser information (including referring URL), your
            preferences and settings, cookies and information about the content
            you have viewed and actions taken (e.g., search queries, ad
            engagement, clicks and the associated dates and times).
            All-Cures.com may also collect device-specific information when you
            install and use an App including your device model, operating system
            information, advertising ID (which is a unique, user-resettable
            identification number for advertising associated with a mobile
            device) and App version and usage information. When enabled by you,
            we collect precise location information provided by your mobile
            device, which you may disable through the device settings.
          </p>
          <h3>Precise Geolocation Data</h3>
          <p>
            When enabled by you, we collect precise location information
            provided by your mobile device. We do so to provide you more
            relevant content including advertising based on your location. You
            may disable the collection and use of your location data through
            your device settings. To change location settings on your device,
            please refer to your device’s official knowledge base.
          </p>
          <h3>Cookies and Other Tracking Technologies</h3>
          <p>
            We and our partners use cookies to collect information about your
            use of the Services. “Cookies” are small data files assigned to your
            browser when you visit an All-Cures.com Site which enable
            recognition of your browser and collect and store information about
            your use of the Services, as described above. In addition to
            cookies, we and our partners use other tracking technologies that
            collect information about your use of the Services, including mobile
            identifiers and "web beacons" which are small graphic files
            (sometimes called “clear GIFs” or “web pixels”) embedded in a web
            page or email typically used to monitor activity and send relevant
            information back to a home server (which can belong to the host
            site, a network advertiser or some other third party). The
            information collected by such tracking technologies may be combined
            with other information that our partners have access to, including
            your name, email address and physical address, so that we can send
            you materials, either electronically or by direct mail, that may be
            of interest to you.
          </p>
          <p>
            Our advertising service partners may use cookies and other tracking
            technologies to collect information about your use of the
            All-Cures.com Sites, including content you have viewed. These third
            parties may use this information to help All-Cures.com deliver
            advertising on the All-Cures.com Sites and on other third party
            websites based on your browsing activity on the All-Cures.com Sites.
            All-Cures.com may further tailor the advertising on the
            All-Cures.com Sites and these other third party websites based on
            additional information to the extent known by All-Cures.com or these
            third parties.
          </p>
          <p>
            We also work with third party ad networks to display advertising on
            our All-Cures.com Sites and on third party websites. Our ad network
            vendors use technologies to collect information about your
            activities on the All-Cures.com Sites and in our flagship
            All-Cures.com App to provide you cookie-based targeted advertising
            on our All-Cures.com Sites and on third party websites based upon
            your browsing activity and your interests.
          </p>
          <p>
            For more information about our how cookies and other tracking
            technologies are used in connection with the Services, please read
            our Cookie Policy.
          </p>
          <p>
            When you download and install one of our Apps onto your mobile
            device we assign a random number to your App installation. This
            number cannot be used to identify you personally, and we cannot
            identify you personally unless you choose to become a registered
            user of the App. We use this random number in a manner similar to
            our use of cookies as described in this Privacy Policy and in our
            Cookie Policy. Unlike cookies, the random number is assigned to your
            installation of the App itself and not a browser, because the App
            does not work through your browser. Therefore the random number
            cannot be removed through settings. If you do not want us to use the
            random number for the purposes for which we use cookies, please do
            not use the Apps. Our use of cookies and other tracking technologies
            on our mobile optimized sites and our flagship All-Cures.com App are
            similar to our use on our desktop sites. Your choices to reject
            cookies, use the Network Advertising Initiative and the opt-out
            mechanism described below in the section "Your Choices and Rights"
            are available on our flagship All-Cures.com App and on our mobile
            optimized sites.
          </p>
          <h3>Cross-Device Tracking</h3>
          <p>
            We and our service providers collect and store information about
            users' interactions with unaffiliated websites and applications that
            use our technologies, including cookies and similar tracking
            technologies. This allows us to infer the presence of a common user
            or household behind multiple devices. We do so in order to:
          </p>
          <ul>
            <li>
              provide personalized advertising on each device that is inferred
              from the browsing patterns on all of the devices;
            </li>
            <li>detect and prevent fraud;</li>
            <li>
              allow users to use our service on one device and pick up
              seamlessly where they left off on another device;
            </li>
            <li>
              limit the number of times a user is shown the same advertisement,
              across known or inferred devices
            </li>
          </ul>
          <p>
            For information on your advertising choices and opt-out, please see
            the "Your Choices and Rights" section of this Privacy Notice.
          </p>
        </section>
        <section>
          <h2>How Information Collected About You Is Used</h2>
          <p>
            Information about your use of the Services may be used for the
            following purposes:
          </p>
          <ul>
            <li>to provide, improve and create new Services,</li>
            <li>
              to respond to your inquiries and to send you administrative
              communications about the All-Cures.com Sites and Services,
            </li>
            <li>
              to obtain your feedback about the All-Cures.com Sites and
              Services,
            </li>
            <li>
              to send you secure electronic messages and personalized emails
              pertaining to your interests as inferred from your use of the
              Services, including news, announcements, reminders and
              opportunities from All-Cures.com,
            </li>
            <li>
              to statistically analyze trends and user behavior and activity
              including how frequently areas of the All-Cures.com Sites are
              visited, how the Services are being used and how many emails are
              received and opened,
            </li>
            <li>
              to provide you and people with similar demographic characteristics
              and interests with more relevant content including advertising
              both on and off the All-Cures.com Sites and Apps,
            </li>
            <li>to offer lead generation services,</li>
            <li>
              to detect and defend against fraud and other threats to the
              Services and our users,
            </li>
            <li>to identify issues with the Services,</li>
            <li>
              to conduct research and measurement activities, including those
              described below, and
            </li>
            <li>to administer your account.</li>
          </ul>
          <p>
            In addition, All-Cures.com may use personal information about you
            for other purposes that are disclosed to you at the time we collect
            the information and/or with your consent.
          </p>
          <p>
            All-Cures.com may combine your personal information and other
            information collected about your use of the Services, and also
            supplement with information from external sources for the purposes
            described in this Privacy Policy. For example, information that
            All-Cures.com collects about you may be combined by All-Cures.com
            with other information available to All-Cures.com through third
            parties for research and measurement purposes, including measuring
            the effectiveness of content, advertising or programs. This
            information from other sources may include age, gender, demographic,
            geographic, personal interests, product purchase activity or other
            information. We may report aggregate information, which is not able
            to be identified back to an individual user of the All-Cures.com
            Sites, to our current or prospective advertisers and other business
            partners.
          </p>
        </section>
        <section>
          <h2>Sharing Your Information</h2>
          <h3>All-Cures.com Subsidiaries and Corporate Affiliates</h3>
          <p>
            We may share your information with our subsidiaries, affiliates and
            companies acquired by or merged with us and our affiliates. In the
            event of a corporate change in control resulting from, for example,
            a sale to, or merger with, another entity, or in the event of a sale
            of assets or a bankruptcy, All-Cures.com reserves the right to
            transfer your personal information to the new party in control or
            the party acquiring assets. In the event of such a change, your
            personal information will continue to be treated in accordance with
            this Privacy Policy unless any changes to the Privacy Policy are
            made in accordance with the section below that discusses “Changes to
            This Privacy Policy.”
          </p>
          <h3>Companies and Contractors that Work with All-Cures.com</h3>
          <p>
            All-Cures.com works with third party companies and contractors that
            help us provide the Services and to otherwise assist in the
            operation of the All-Cures.com Sites and Apps, including those that
            provide services relating to technology, data analysis, research,
            email management and deployment, sweepstakes and contest
            administration, advertising and marketing and/or content.
            All-Cures.com contractors sometimes have limited access to your
            information in the course of providing products or services to
            All-Cures.com. We contractually require that our contractors not use
            or disclose your information for any purpose other than providing
            the limited service or function for All-Cures.com.
          </p>
          <h3>Third Party Advertisers and Third Party Websites</h3>
          <p>
            We may share information that we have about you, such as a cookie ID
            or IP address, with third party advertising service providers who
            may use this information, on our behalf, to help All-Cures.com
            deliver advertising on the All-Cures.com Sites as well as on third
            party websites, as further described in our Cookie Policy.
          </p>
          <p>
            Certain content, services and advertisements offered to you through
            the All-Cures.com Sites are served on, or contain links to, websites
            hosted and operated by a company other than All-Cures.com ("Third
            Party Websites"). All-Cures.com does not share your personal
            information with these Third Party Websites without your consent,
            but you should be aware that any information you disclose to these
            Third Party Websites once you access these Third Party Websites is
            not subject to this Privacy Policy. All-Cures.com does not endorse
            and is not responsible for the privacy practices of these Third
            Party Websites. You should review the privacy policy posted on the
            Third Party Website to understand how that Third Party Website
            collects and uses your information. All-Cures.com makes an effort to
            make it obvious to you when you leave an All-Cures.com Site and
            enter a Third Party Website, either by requiring you to click on a
            link or by notifying you on the All-Cures.com Site before you visit
            the third party site. In addition, if you see a phrase such as
            "Powered by" or "in association with" followed by the name of a
            company other than All-Cures.com, then you are on a website hosted
            by a company other than All-Cures.com.
          </p>
          <p>
            We may also include social widgets on the All-Cures.com Sites which
            enable you to interact with the associated social media services,
            e.g., to share an article. These widgets may collect browsing data
            which may be received by the third party that provided the widget,
            and are controlled by these third parties. You may be able to manage
            your privacy preferences directly with the applicable social network
            platform.
          </p>
          <h3>Compliance with Law, Regulation, and Law Enforcement Requests</h3>
          <p>
            To cooperate with government and law enforcement officials and
            private parties to enforce and comply with law, we may release
            personal information to third parties: (1) to comply with legal
            requirements such as a law, regulation, search warrant, subpoena or
            court order; (2) when we believe in good faith that disclosure is
            necessary to protect our rights, protect your safety or the safety
            of others, investigate fraud, or respond to a government request; or
            (3) in special cases, such as in response to a physical threat to
            you or others, to protect property or defend or assert legal rights.
            In addition, we may disclose personal information as described
            below.
          </p>
        </section>
        <section>
          <h2>How Your Information is Secured and Retained</h2>
          <p>
            We take reasonable security measures to protect the security of your
            personal information. Despite All-Cures.com's efforts to protect
            your personal information, there is always some risk that an
            unauthorized third party may find a way around our security systems
            or that transmissions of your information over the Internet may be
            intercepted.
          </p>
          <p>
            The security of your personal information is important to us. When
            you enter personal information (including personal health
            information in various Services), we encrypt the transmission of
            that information or use SSL connections (Secure Socket Layer)
            technology.
          </p>
          <p>
            We will retain your personal information as long as your account is
            active or as needed to provide you Services. At any time you can
            remove your personal information or instruct us to remove it, but
            you should be aware that it is not technologically possible to
            remove each and every record of the information you have provided to
            All-Cures.com from our servers. See “Your Choices and Rights” below
            for more information on how you can update or remove your personal
            information. We will also retain your personal information as
            necessary to comply with legal obligations, resolve disputes and
            enforce our agreements.
          </p>
        </section>
        <section>
          <h2>Your Choices and Rights</h2>
          <h3>Updating/Removing Your Personal Information</h3>
          <p>
            If you do not want your personal information used by All-Cures.com
            as provided in this Privacy Policy, you should not use the
            All-Cures.com, Apps and Services. You can correct, update or review
            personal information you have previously submitted by going back to
            the specific Service, logging-in and making the desired change. You
            can also update any personal information you have submitted by
            contacting us using the contact information listed below or through
            the Contact Us link provided at the bottom of every page of the
            All-Cures.com Sites.
          </p>
          <p>
            When you sign up to receive email communications for any of our
            Services, including our email newsletters, or at any time, you can
            choose to opt out of receiving additional newsletters or other email
            communications from All-Cures.com or our advertisers or sponsors.
          </p>
          <p>You can unsubscribe from an email newsletter by:</p>
          <ul>
            <li>
              Following the directions included at the bottom of the newsletter
              and using the “Unsubscribe” link found in the emails.
            </li>
            <li>
              Logging in to the All-Cures.com Sites and unchecking the
              newsletters you no longer wish to receive under the “My Profile”
              section.
            </li>
          </ul>
          <p>
            If you decide that you would prefer not to receive personalized
            email or secure electronic messages from the All-Cures.com Health
            Tracker tool, you may also "Opt-out" of the Service by clicking on
            the settings tab on your Health Tracker home page and changing your
            email preference or following the unsubscribe instructions included
            in each email.
          </p>
          <p>
            All promotional emails that All-Cures.com sends with opportunities
            from All-Cures.com or with offers or informational materials from
            All-Cures.com on behalf of our sponsors will contain an opportunity
            to unsubscribe from getting additional emails of that type in the
            future from All-Cures.com unless you re-subscribe.
          </p>
          <h3>Cookies</h3>
          <p>
            Most browser software can be set to reject Cookies. Most browsers
            offer instructions on how to reset the browser to reject Cookies in
            the "Help" or “Settings” or “Preferences” section of your browser’s
            toolbar. Refer to our Cookie Policy for additional information about
            opting out of Cookies.
          </p>
          <h3>Mobile Opt-out</h3>
          <p>
            You may also control interest-based advertising on your mobile
            device by enabling the “Limit Ad Tracking” setting in your iOS
            device’s settings or “Opt out of Ads Personalization” in your
            Android device’s settings. This will not prevent you from seeing
            advertisements, but will limit the use of device advertising
            identifiers to personalize ads based on your interests. If you have
            questions about how to reject cookies on your specific device please
            check with the device manufacturer.
          </p>
          <h3>
            Contacting All-Cures.com About Your Personal Information or Privacy
          </h3>
          <p>
            Please send us an email by using the Contact Us link at the bottom
            of every page of the All-Cures.com Sites if you have any questions
            about this Privacy Policy or the personal information we maintain
            about you. We will respond to your request within a reasonable
            timeframe.
          </p>
        </section>
        <section>
          <h2>Changes to this Privacy Policy</h2>
          <p>
            We reserve the right to change or modify this Privacy Policy and any
            of our Services at any time and any changes will be effective upon
            being posted unless we advise otherwise. If we make any material
            changes to this Privacy Policy we will notify you by means of a
            notice on the All-Cures.com Sites and/or by email to our registered
            users (sent to the email address specified when you register) prior
            to the change becoming effective. By continuing to use the Services
            after changes are made to this Privacy Policy, you agree to such
            changes. We encourage you to periodically review this Privacy Policy
            for the latest information on our privacy practices. If you do not
            accept the terms of this Privacy Policy, we ask that you do not
            register with us and that you do not use the All-Cures.com Sites.
            Please exit the All-Cures.com Sites immediately if you do not agree
            to the terms of this Privacy Policy.
          </p>
        </section>
      </div>
    </>
  );
};

export default PrivacyPolicy;
